import React, { useState, useEffect } from 'react';

const BrandReviewsSlider2 = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const reviews = [
    {
      text: "As a small business owner, managing my Amazon store was overwhelming. But after partnering with this team, they took over everything—from pricing strategies to PPC management—and the results speak for themselves. Our brand is now growing every day!",
      author: "Briallen Skovik",
      brand: "My Go-To Amazon Experts",
      rating: 5,
      color: "text-orange-500",
    },
    {
      text: "We've seen a dramatic improvement in both our product rankings and sales. Their team is proactive, knowledgeable, and really understands the Amazon marketplace. I couldn't ask for a better partner to help manage my account.",
      author: "Tharen Quilby",
      brand: "Boosted Our Rankings and Sales!",
      rating: 5,
      color: "text-blue-500",
    },
    {
      text: "I've worked with other Amazon consultants before, but no one has delivered results like this. Our conversion rates are up, our products are getting more visibility, and our overall Amazon sales are growing faster than ever. Thank you!",
      author: "Ellory Flintwood",
      brand: "The Growth We've Seen is Incredible!",
      rating: 5,
      color: "text-green-500",
    },
    {
      text: "Their graphic design work has had a huge impact on our sales. The new, vibrant product images and A+ content have helped our products stand out in a crowded marketplace. We've definitely seen a higher conversion rate since the update.",
      author: "Riven Cardrow",
      brand: "Game-Changing for Our Amazon Store",
      rating: 5,
      color: "text-purple-500",
    },
    {
      text: "I've tried managing PPC myself, but this team took it to the next level. Their insights and campaign management have drastically improved our sales, and we're spending less on ads to get more results. Couldn't be happier!",
      author: "Cazriel Montry",
      brand: "Incredible ROI from PPC!",
      rating: 5,
      color: "text-pink-500",
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((current) => (current + 1) % reviews.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [reviews.length]);

  return (
    <section className="text-white py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="mx-auto w-fit block bg-primary/20 text-primary px-6 py-2 rounded-full text-sm font-medium mb-6">
            SUCCESS STORIES
          </div>
        <div className="mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-5xl md:text-6xl font-bold leading-tight">
              We’ve helped 100+ brands reach new heights of success.
            </h2>
          </div>
          <div>
            <p className="text-lg text-white/80">
              We truly value the feedback you share with us. It's our pleasure to work with you and see your brand succeed.
            </p>
          </div>
        </div>

        {/* Carousel Container */}
        <div className="max-w-7xl mx-auto">
          <div className="relative">
            {/* Main Review */}
            <div className="relative z-10">
              {reviews.map((review, index) => (
                <div
                  key={index}
                  className={`transition-all duration-700 ${
                    index === activeIndex ? 'opacity-100' : 'opacity-0 absolute inset-0'
                  }`}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left Side - Quote */}
                    <div className="relative">
                      <div className="absolute -top-8 -left-8">
                        <svg className={`w-16 h-16 ${review.color} opacity-20`} fill="currentColor" viewBox="0 0 24 24">
                          <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"/>
                        </svg>
                      </div>
                      <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
                        <p className="text-2xl font-medium mb-8">{review.text}</p>
                        <div className="flex items-center gap-4">
                          <div className="flex-1">
                            <p className={`font-semibold ${review.color}`}>{review.author}</p>
                            <p className="text-white/60">{review.brand}</p>
                          </div>
                          <div className="flex gap-1">
                            {[...Array(review.rating)].map((_, i) => (
                              <svg key={i} className={`w-5 h-5 ${review.color}`} fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                              </svg>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Side - Preview Cards */}
                    <div className="relative h-[400px]">
                      {reviews.map((previewReview, previewIndex) => {
                        const offset = ((previewIndex - activeIndex + reviews.length) % reviews.length);
                        const zIndex = reviews.length - offset;
                        const translateY = offset * 60;
                        const scale = 1 - (offset * 0.1);
                        const opacity = 1 - (offset * 0.3);

                        return (
                          <div
                            key={previewIndex}
                            className="absolute inset-0 transition-all duration-700"
                            style={{
                              transform: `translateY(${translateY}px) scale(${scale})`,
                              opacity: opacity,
                              zIndex: zIndex,
                            }}
                          >
                            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 cursor-pointer"
                                 onClick={() => setActiveIndex(previewIndex)}>
                              <p className="text-lg line-clamp-2 mb-4">{previewReview.text}</p>
                              <div className="flex items-center justify-between">
                                <p className={`font-medium ${previewReview.color}`}>{previewReview.author}</p>
                                <div className={`w-8 h-8 rounded-full ${previewReview.color} bg-opacity-20 flex items-center justify-center`}>
                                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandReviewsSlider2;
